/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshoplanguage4Inputs */

const de__field_participatedulworkshoplanguage4 = /** @type {(inputs: _Field_Participatedulworkshoplanguage4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Language`)
};

/**

* @param {_Field_Participatedulworkshoplanguage4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshoplanguage4 = /** @type {((inputs?: _Field_Participatedulworkshoplanguage4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshoplanguage4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshoplanguage4(inputs)
});
export { _field_participatedulworkshoplanguage4 as "_field_participatedULWorkshopLanguage" }